exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fs-16[data-v-9dd508ae] {\n  font-size: 1.15em !important;\n}", ""]);

// exports
